import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/queryClient';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { ToastContainer } from '@/components/notifications/ToastContainer';
import { Toaster } from 'react-hot-toast';
import type { PropsWithChildren } from 'react';

import { useEffect } from 'react';
import { useAuthStore } from '@/app/store/authStore';

// Single composition root for every app-wide provider. main.tsx only
// ever imports this one component, so adding a new provider (theme,
// i18n, feature flags) never means touching main.tsx again.
export function AppProviders({ children }: PropsWithChildren) {
  const checkAuth = useAuthStore(state => state.checkAuth);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {children}
        <ToastContainer />
        <Toaster position="top-right" />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
